import React, { Fragment, useMemo } from 'react';
import { useYotpo } from '../useYotpo';
import { LightboxStyles, ReviewsSectionWrapper, ReviewsTitle } from './styled';
import { getYotpoApiKey, isServerSideRendering } from 'helpers/env';

const apiKey = getYotpoApiKey();

type YotpoProductProps = {
  className?: string;
  productId: string;
  productPrice?: string;
  productUrl?: string;
  productName?: string;
  productImage?: string;
  reviewHtml: string;
};
const Yotpo = ({
  className = '',
  productUrl,
  productId,
  productPrice,
  productName,
  productImage,
  reviewHtml
}: YotpoProductProps): React.JSX.Element => {
  useYotpo(apiKey);

  // Only return inner HTML of review content during SSR for SEO purposes
  const innerHtml = useMemo(() =>
      isServerSideRendering() ? { __html: reviewHtml } : undefined,
    [reviewHtml]);

  return (
    <Fragment>
      <LightboxStyles />
      <ReviewsSectionWrapper className={className}>
        <button className="button-link" id="yotpo-reviews-anchor" />
        <ReviewsTitle>Take it from our community...</ReviewsTitle>
        <div
          id="y-embedded-widget"
          className="yotpo yotpo-main-widget"
          data-appkey={apiKey}
          data-product-id={productId}
          data-price={productPrice}
          data-name={productName}
          data-url={productUrl}
          data-image-url={productImage}
          dangerouslySetInnerHTML={innerHtml}
        />
      </ReviewsSectionWrapper>
    </Fragment>
  );
};

export default Yotpo;
